"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyBotOrderUtils = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const OrderGroupUtils_1 = require("./OrderGroupUtils");
var CopyBotOrderUtils;
(function (CopyBotOrderUtils) {
    function _convertCopyBotOrder(value) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return {
            quote_investment: value.bu_order_data.quote_investment,
            share_ratio: value.bu_order_data.share_ratio,
            follow_type: value.bu_order_data.follow_type,
            quote_amount: value.bu_order_data.quote_amount,
            usable_quote_amount: trade_utils_lib_1.SafeDecimal.max(0, new trade_utils_lib_1.SafeDecimal(value.bu_order_data.quote_investment)
                .add(new trade_utils_lib_1.SafeDecimal(value.bu_order_data.close_profit))
                .sub(new trade_utils_lib_1.SafeDecimal(value.bu_order_data.running_order_quote_investment))),
            status: value.bu_order_data.status,
            running_order_count: value.bu_order_data.running_order_count,
            running_order_quote_investment: value.bu_order_data.running_order_quote_investment,
            close_profit: value.bu_order_data.close_profit,
            profit_stop_type: value.bu_order_data.profit_stop_type,
            profit_stop: value.bu_order_data.profit_stop,
            loss_stop_type: value.bu_order_data.loss_stop_type,
            loss_stop: value.bu_order_data.loss_stop,
            gridProfit: 0,
            gridProfitPercent: 0,
            unRealizedProfit: 0,
            unrealizedProfitPercent: 0,
            totalProfit: 0,
            totalProfitPercent: 0,
            kol_avatar: value.bu_order_data.kol_avatar,
            kol_nickname: value.bu_order_data.kol_nickname,
            single_fix_amount: value.bu_order_data.single_fix_amount,
            min_investment_select: value.bu_order_data.min_investment_select,
            running_action: value.bu_order_data.running_action,
            received_share_profit: value.bu_order_data.received_share_profit,
            given_share_profit: value.bu_order_data.given_share_profit,
            share_mode: value.bu_order_data.share_mode,
            invest_min: value.bu_order_data.invest_min,
            group_info: value.bu_order_data.group_info
                ? {
                    group_id: value.bu_order_data.group_info.group_id,
                    quote_type: value.bu_order_data.group_info.quote_type,
                    order_nums: value.bu_order_data.group_info.order_nums,
                    name: value.bu_order_data.group_info.name,
                    create_time: value.bu_order_data.group_info.create_time,
                    quote_type_investment: value.bu_order_data.group_info.quote_type_investment,
                    totalProfit: 0,
                    totalProfitPercent: 0,
                    positiveSubOrderTotalProfit: 0,
                    negativeSubOrderTotalProfit: 0,
                    positionValue: 0,
                    state: value.bu_order_data.group_info.state,
                    current_portfolio_list: (_a = value.bu_order_data.group_info.current_portfolio_list) !== null && _a !== void 0 ? _a : [],
                    group_sub_order_types: (_b = value.bu_order_data.group_info.group_sub_order_types) !== null && _b !== void 0 ? _b : [],
                    group_sub_types: (_c = value.bu_order_data.group_info.group_sub_types) !== null && _c !== void 0 ? _c : [],
                    position_list: (_d = value.bu_order_data.group_info.position_list) !== null && _d !== void 0 ? _d : [],
                    sub_order_list: (_f = (_e = value.bu_order_data.group_info.sub_order_list) === null || _e === void 0 ? void 0 : _e.map((item) => {
                        var _a, _b, _c;
                        return {
                            bu_order_id: item.bu_order_id,
                            start_time: item.start_time,
                            quote_type_investment: item.quote_type_investment,
                            quote: item.quote,
                            current_portfolio_list: (_a = item.current_portfolio_list) !== null && _a !== void 0 ? _a : [],
                            position_list: (_b = item.position_list) !== null && _b !== void 0 ? _b : [],
                            totalProfit: 0,
                            dynamic_margin: (_c = item.dynamic_margin) !== null && _c !== void 0 ? _c : "",
                            open_quote_price: new trade_utils_lib_1.SafeDecimal(item.open_quote_price).toNumber(),
                            positionValue: 0,
                            order_status: item.order_status,
                        };
                    })) !== null && _f !== void 0 ? _f : [],
                    create_from: (_g = value.bu_order_data.group_info.create_from) !== null && _g !== void 0 ? _g : "user",
                    group_detail_hidden: (_h = value.bu_order_data.group_info.group_detail_hidden) !== null && _h !== void 0 ? _h : false,
                }
                : undefined,
        };
    }
    CopyBotOrderUtils._convertCopyBotOrder = _convertCopyBotOrder;
    function _calcCopyBotOrderProfit(item, basesTickers) {
        if (item.exchangeCopyBotOrder === undefined) {
            return item;
        }
        else {
            const groupOrder = item.exchangeCopyBotOrder.group_info
                ? OrderGroupUtils_1.OrderGroupUtils.__calcOrderGroupProfitImp(item.exchangeCopyBotOrder.group_info, basesTickers)
                : item.exchangeCopyBotOrder.group_info;
            const investment = new trade_utils_lib_1.SafeDecimal(item.exchangeCopyBotOrder.quote_investment);
            const gridProfit = new trade_utils_lib_1.SafeDecimal(item.exchangeCopyBotOrder.close_profit);
            const unRealizedProfit = new trade_utils_lib_1.SafeDecimal(groupOrder === null || groupOrder === void 0 ? void 0 : groupOrder.totalProfit);
            const tempTotalProfit = unRealizedProfit.add(gridProfit);
            const totalProfitPercent = investment.equals(0) ? 0 : tempTotalProfit.div(investment).mul(100).toNumber();
            const unRealizedProfitPercent = investment.equals(0) ? 0 : unRealizedProfit.div(investment).mul(100).toNumber();
            const gridProfitPercent = investment.equals(0) ? 0 : gridProfit.div(investment).mul(100).toNumber();
            return Object.assign(Object.assign({}, item), { exchangeCopyBotOrder: Object.assign(Object.assign({}, item.exchangeCopyBotOrder), { gridProfit: gridProfit.toNumber(), gridProfitPercent: gridProfitPercent, unRealizedProfit: unRealizedProfit.toNumber(), unrealizedProfitPercent: unRealizedProfitPercent, totalProfit: tempTotalProfit.toNumber(), totalProfitPercent: totalProfitPercent, group_info: Object.assign(Object.assign({}, groupOrder), { totalProfitPercent: unRealizedProfitPercent }) }) });
        }
    }
    CopyBotOrderUtils._calcCopyBotOrderProfit = _calcCopyBotOrderProfit;
})(CopyBotOrderUtils = exports.CopyBotOrderUtils || (exports.CopyBotOrderUtils = {}));
